import type { Injector } from '@angular/core';
import { RetryLink } from '@apollo/client/link/retry';
import { NetworkStatusService } from '@shared/services/network-status.service';
import { UserService } from '@features/sign-in/services/user.service';

export const retryLink = (injector: Injector) => {
  return new RetryLink({
    delay: { max: 2000 },
    attempts: {
      max: Infinity,
      retryIf: (error) => {
        if (!injector.get(UserService).isLoggedIn) {
          return false;
        }
        if (injector.get(NetworkStatusService).isOffline()) {
          return true;
        }
        const isNetworkError =
          error.networkError &&
          (error.networkError.message === 'Network request failed' ||
            error.networkError.message.includes('Failed to fetch') ||
            error.networkError.message.includes('NetworkError'));
        const status = error?.status || error?.networkError?.statusCode;
        const isServerError = (status >= 500 && status < 600) || status === 401;
        return isNetworkError || isServerError;
      },
    },
  });
};
